import React from 'react'
import OtpInputs from './OtpInputs/OtpInputs'
import LanguageTranslater from "../HOC/LanguageTranslater";
import { Button } from 'unified-ui-components-library';

function OtpScreen(props) {
    const {
        planName,
        customerMobNum,
        errMsg,
        annualPremium,
        checkboxValue,
        sendOtp,
        submitOtp,
        sendOtpTime,
        disableOtpButton,
        disableSubmitButton,
        showSendOtpTime
    } = props.otpScreenProps

    const { translate } = props

    const getFormattedTime = (sec) => {
        let min = Math.floor(sec / 60)
        let second = sec % 60
        return `0${min}:${second < 10 ? '0' + second : second}`
    }

    return (
        <div>
            <div className="cd-responsive">
                <div className="cd-head-text-cntnr">

                    <p style={{ paddingTop: '18px', }} className="cd-plan-name-text">
                        Please complete the payment for your {planName}
                    </p>
                </div>
            </div>
            <div className="cd-main-text-cntnr">

                <div>
                    <div className='cd-user-details-container monthly-premium-cntnr'>
                        <p className='cd-user-detail monthly-premium-text'>Premium </p>
                        <p className='cd-user-value monthly-premium-value'>₹ {annualPremium}</p>
                    </div>
                </div>

            </div>

            <div className="scroll">
                <div className="sub-scroll">
                    <div className="cd-declaration-main-cntnr">
                        <div className="otp-box-cntnr">
                            <div className="cd-enter-otp-1">
                                <p className="cd-enter-otp-text">
                                    {translate(" Enter OTP")}
                                </p>
                            </div>
                            <div className="cd-enter-otp-2">
                                <p className="cd-mob-num-text">
                                    A 6 digit verification code is sent to your registered mobile number ******{customerMobNum}
                                </p>
                            </div>
                            <div className='cd-otp-inputs-cntnr'>
                                <OtpInputs />
                            </div>
                            <div className="cd-send-otp-btn-cntnr">

                                <p className='cd-send-otp-timer'>{
                                    errMsg ? <span style={{ color: '#c40000' }}>*{errMsg}</span> : <span> Didn’t receive an OTP ?</span>
                                }
                                    {
                                        showSendOtpTime ?
                                            <span style={{ fontWeight: 'bold' }}> Resend in <span style={{ color: 'green' }}> {getFormattedTime(sendOtpTime)}</span> </span> :
                                            <button
                                                className={disableOtpButton ? 'cd-send-otp-btn-disabled' : 'cd-send-otp-btn'}
                                                disabled={disableOtpButton}
                                                onClick={sendOtp}
                                            >  Resend OTP</button>
                                    }
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="cd-btn-cntnr">
                        <div className="button_div_unified cd_pay_btn">
                            <Button
                                // className='cd-submit-btn'
                                onClick={submitOtp}
                                disabled={disableSubmitButton || !checkboxValue}
                                buttonType='primary'
                                width="264"
                            >
                                {translate("Submit")}
                            </Button>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    )
}

export default LanguageTranslater(OtpScreen)